<p class="sr-only">
  Vorschau deiner Marke auf der Shopseite, in der Gutschein-App und auf dem Gutschein-PDF.
</p>

<div class="grid gap-4 sm:grid-cols-3" aria-hidden="true">
  <!-- Storefront header -->
  <figure class="space-y-2">
    <div class="bg-background overflow-hidden rounded-lg border">
      @if (bannerUrl(); as banner) {
        <img [src]="banner" alt="" class="h-14 w-full object-cover" />
      } @else {
        <div class="bg-muted h-14"></div>
      }
      <div class="flex items-center gap-2 px-2.5 pt-0 pb-3">
        <div
          class="bg-muted text-muted-foreground border-background -mt-4 flex size-9 shrink-0 items-center justify-center overflow-hidden rounded-full border-2">
          @if (logoUrl(); as logo) {
            <img [src]="logo" alt="" class="size-full object-cover" />
          } @else {
            <ng-icon name="lucideImage" size="14" />
          }
        </div>
        <span class="mt-1 truncate text-xs font-semibold">{{ displayName() }}</span>
      </div>
      <div class="flex gap-1 px-2.5 pb-3">
        @for (step of [1, 2, 3]; track step) {
          <span
            class="flex size-5 items-center justify-center rounded-full text-[10px] font-semibold"
            [style.background-color]="primary()"
            [style.color]="onPrimary()">
            {{ step }}
          </span>
        }
      </div>
    </div>
    <figcaption class="text-muted-foreground text-xs">Shopseite</figcaption>
  </figure>

  <!-- Voucher app -->
  <figure class="space-y-2">
    <div class="bg-background flex h-[7.25rem] flex-col justify-between rounded-lg border p-2.5">
      <div class="space-y-1.5">
        <span class="bg-muted-foreground/25 block h-2 w-3/5 rounded-full"></span>
        <span class="bg-muted-foreground/15 block h-1.5 w-full rounded-full"></span>
        <span class="bg-muted-foreground/15 block h-1.5 w-4/5 rounded-full"></span>
      </div>
      <span
        class="flex items-center justify-center gap-1 rounded-md py-1.5 text-[11px] font-semibold"
        [style.background-color]="primary()"
        [style.color]="onPrimary()">
        <ng-icon name="lucideGift" size="12" />
        Gutschein kaufen
      </span>
    </div>
    <figcaption class="text-muted-foreground text-xs">Gutschein-App</figcaption>
  </figure>

  <!-- Voucher PDF (a template with logo and banner) -->
  <figure class="space-y-2">
    <div class="bg-background flex h-[7.25rem] flex-col overflow-hidden rounded-lg border">
      @if (bannerUrl(); as banner) {
        <img [src]="banner" alt="" class="h-8 w-full object-cover" />
      } @else {
        <div class="h-8" [style.background-color]="primary()"></div>
      }
      <div class="flex flex-1 flex-col items-center justify-center gap-1 px-2 text-center">
        @if (logoUrl(); as logo) {
          <img [src]="logo" alt="" class="size-6 rounded-full object-cover" />
        }
        <span class="truncate text-[10px] font-semibold">{{ displayName() }}</span>
        <span class="text-[13px] font-bold tabular-nums" [style.color]="primary()">{{
          samplePrice()
        }}</span>
      </div>
    </div>
    <figcaption class="text-muted-foreground text-xs">Gutschein-PDF</figcaption>
  </figure>
</div>
